"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogger = void 0;
var formatter_1 = require("../formatter");
var logger_1 = require("./logger");
var ConsoleLogger = (function () {
    function ConsoleLogger(level) {
        if (level === void 0) { level = logger_1.LogLevel.Trace; }
        this.level = level;
    }
    ConsoleLogger.prototype.levelToNumber = function (level) {
        switch (level) {
            case logger_1.LogLevel.Trace: return 0;
            case logger_1.LogLevel.Debug: return 1;
            case logger_1.LogLevel.Info: return 2;
            case logger_1.LogLevel.Warning: return 3;
            case logger_1.LogLevel.Error: return 4;
            default: return 0;
        }
    };
    ConsoleLogger.prototype.logf = function (level) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.levelToNumber(level) < this.levelToNumber(this.level)) {
            return;
        }
        var prefix = formatter_1.Formatter.writeZoneDateTime(new Date()) + ' [' + logger_1.LogLevel[level] + ']: ';
        switch (level) {
            case logger_1.LogLevel.Trace:
                console.log.apply(console, __spreadArray(['%c' + prefix, 'color: grey; font-style: italic;'], args, false));
                break;
            case logger_1.LogLevel.Debug:
                console.log.apply(console, __spreadArray(['%c' + prefix, 'color: grey; font-weight: normal;'], args, false));
                break;
            case logger_1.LogLevel.Info:
                console.log.apply(console, __spreadArray(['%c' + prefix, 'color: blue; font-weight: normal;'], args, false));
                break;
            case logger_1.LogLevel.Warning:
                console.log.apply(console, __spreadArray(['%c' + prefix, 'color: orange; font-weight: bold;'], args, false));
                break;
            case logger_1.LogLevel.Error:
                console.log.apply(console, __spreadArray(['%c' + prefix, 'color: red; font-weight: bold;'], args, false));
                break;
            default:
                console.log.apply(console, __spreadArray(['%cUnknown LogLevel: ' + level, 'color: red; font-weight: bold;'], args, false));
                break;
        }
    };
    return ConsoleLogger;
}());
exports.ConsoleLogger = ConsoleLogger;
//# sourceMappingURL=logger.console.js.map